import styles from "./IconButton.module.scss";

interface IconButtonProps {
  icon: string;
  "aria-label": string;
  className?: string;
  onClick?: () => void;
}

export function IconButton({
  icon,
  className,
  onClick,
  "aria-label": ariaLabel,
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={[styles.button, className].filter(Boolean).join(" ")}
      onClick={onClick}
    >
      <img src={icon} alt="" draggable={false} />
    </button>
  );
}
